import React from 'react';
import { useTranslation } from 'react-i18next';

import { Option } from '@umanforge/common';
import SafetyCrossSettings from 'components/modals/eventManagers/safetyCrossSettings.component';
import { Theme } from 'interfaces/theme.interface';

interface SafetyCrossSectionProps {
  themesOption: Option<Theme>[];
  createEventOnWarning: boolean;
  setCreateEventOnWarning: ( value: boolean ) => void;
  createEventOnError: boolean;
  setCreateEventOnError: ( value: boolean ) => void;
  safetyCrossThemeWarningId: string | null;
  setSafetyCrossThemeWarningId: ( value: string | null ) => void;
  safetyCrossThemeErrorId: string | null;
  setSafetyCrossThemeErrorId: ( value: string | null ) => void;
}

const SafetyCrossSection: React.FC<SafetyCrossSectionProps> = ( {
  themesOption,
  createEventOnWarning,
  setCreateEventOnWarning,
  createEventOnError,
  setCreateEventOnError,
  safetyCrossThemeWarningId,
  setSafetyCrossThemeWarningId,
  safetyCrossThemeErrorId,
  setSafetyCrossThemeErrorId,
} ) => {
  const { t } = useTranslation();

  return (
    <>
      <h3 className="font-bold mb-3">{ t( 'translation:safety_cross' ) }</h3>
      <SafetyCrossSettings
        themesOption={ themesOption }
        createEventOnWarning={ createEventOnWarning }
        setCreateEventOnWarning={ setCreateEventOnWarning }
        createEventOnError={ createEventOnError }
        setCreateEventOnError={ setCreateEventOnError }
        safetyCrossThemeWarningId={ safetyCrossThemeWarningId }
        setSafetyCrossThemeWarningId={ setSafetyCrossThemeWarningId }
        safetyCrossThemeErrorId={ safetyCrossThemeErrorId }
        setSafetyCrossThemeErrorId={ setSafetyCrossThemeErrorId }
      />
    </>
  );
};

export default SafetyCrossSection;
